// BasicAnalytics.jsx - LINE CHART GRAPH (Screenshot Exact Match)
import React, { useState, useEffect } from 'react'
import MyMasterLayout from './../../../layouts/Mentor/MyMasterlayout';
import './../../../assets/css/mentor/mentordashboard/BasicAnalytics.css';

const analyticsData = {
  totalStudents: 45,
  totalSessions: 128,
  avgRating: 4.7,
  satisfaction: 92,
  weeklyTrend: [
    { week: 'W1', sessions: 15 },
    { week: 'W2', sessions: 22 },
    { week: 'W3', sessions: 18 },
    { week: 'W4', sessions: 28 },
    { week: 'W5', sessions: 35 },
    { week: 'W6', sessions: 32 }
  ],
  ratingDistribution: [
    { rating: 5, count: 34, color: '#10b981' },
    { rating: 4, count: 8, color: '#f59e0b' },
    { rating: 3, count: 2, color: '#ef4444' },
    { rating: 2, count: 1, color: '#dc2626' },
    { rating: 1, count: 0, color: '#991b1b' }
  ]
};

const BasicAnalytics = () => {
  const renderLineChart = () => {
    const data = analyticsData.weeklyTrend;
    const maxValue = Math.max(...data.map(d => d.sessions));
    const width = 600;
    const height = 250;
    const padding = 40;
    
    const points = data.map((point, index) => {
      const x = padding + (index * (width - padding * 2)) / (data.length - 1);
      const y = height - padding - (point.sessions / maxValue) * (height - padding * 2);
      return `${x},${y}`;
    }).join(' ');

    return (
      <div className="line-chart-container">
        <svg viewBox={`0 0 ${width} ${height}`} className="line-chart">
          {/* Grid Lines */}
          <g className="grid-lines">
            {Array.from({length: 6}).map((_, i) => (
              <line
                key={i}
                x1="40"
                y1={padding + i * (height - padding * 2) / 5}
                x2={width - padding}
                y2={padding + i * (height - padding * 2) / 5}
                stroke="#e5e7eb"
                strokeWidth="1"
              />
            ))}
          </g>

          {/* X Axis */}
          <line x1="40" y1={height - padding} x2={width - padding} y2={height - padding} 
                stroke="#d1d5db" strokeWidth="2"/>
          
          {/* Y Axis */}
          <line x1="40" y1="40" x2="40" y2={height - padding} 
                stroke="#d1d5db" strokeWidth="2"/>

          {/* Data Points */}
          {data.map((point, index) => {
            const x = padding + (index * (width - padding * 2)) / (data.length - 1);
            const y = height - padding - (point.sessions / maxValue) * (height - padding * 2);
            return (
              <g key={point.week}>
                <circle 
                  cx={x} 
                  cy={y} 
                  r="6" 
                  fill="#3b82f6" 
                  stroke="white"
                  strokeWidth="3"
                  className="data-point"
                />
                <text x={x} y={y - 15} textAnchor="middle" fill="#1f2937" fontSize="12" fontWeight="600">
                  {point.sessions}
                </text>
              </g>
            );
          })}

          {/* Line Path */}
          <polyline 
            points={points} 
            fill="none" 
            stroke="url(#lineGradient)" 
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="line-path"
          />

          {/* Gradient for Line */}
          <defs>
            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3b82f6"/>
              <stop offset="50%" stopColor="#1d4ed8"/>
              <stop offset="100%" stopColor="#1e3a8a"/>
            </linearGradient>
          </defs>

          {/* X Labels */}
          {data.map((point, index) => {
            const x = padding + (index * (width - padding * 2)) / (data.length - 1);
            return (
              <text 
                key={point.week}
                x={x} 
                y={height - 10} 
                textAnchor="middle" 
                fill="#6b7280" 
                fontSize="11"
                fontWeight="500"
              >
                {point.week}
              </text>
            );
          })}
        </svg>
      </div>
    );
  };

  const renderRatingChart = () => {
    return analyticsData.ratingDistribution.map(rating => (
      <div key={rating.rating} className="rating-item">
        <div className="rating-circle" style={{ backgroundColor: rating.color }}>
          <span>{rating.rating}</span>
        </div>
        <div className="rating-count">{rating.count}</div>
        <div className="rating-bar">
          <div 
            className="rating-fill"
            style={{ width: `${(rating.count / 45) * 100}%`, backgroundColor: rating.color }}
          ></div>
        </div>
      </div>
    ));
  };

  return (
    <MyMasterLayout>
      <div>
        {/* Key Metrics */}
        <div className="metrics-grid">
          <div className="metric-card primary">
            <div className="metric-icon"><i className="bi-people-fill"></i></div>
            <div className="metric-value">{analyticsData.totalStudents}</div>
            <div className="metric-label">Total Students</div>
          </div>
          <div className="metric-card success">
            <div className="metric-icon"><i className="bi-calendar-check"></i></div>
            <div className="metric-value">{analyticsData.totalSessions}</div>
            <div className="metric-label">Total Sessions</div>
          </div>
          <div className="metric-card warning">
            <div className="metric-icon"><i className="bi-star-fill"></i></div>
            <div className="metric-value">{analyticsData.avgRating}</div>
            <div className="metric-label">Avg Rating</div>
          </div>
          <div className="metric-card info">
            <div className="metric-icon"><i className="bi-heart-fill"></i></div>
            <div className="metric-value">{analyticsData.satisfaction}%</div>
            <div className="metric-label">Satisfaction</div>
          </div>
        </div>

        <div className="analytics-grid">
          {/* LINE CHART - Exact Screenshot Match */}
          <div className="card">
            <div className="card-header">
              <h2 className="section-title">
                <i className="bi-graph-up"></i> Weekly Sessions Trend
              </h2>
            </div>
            <div className="chart-container">
              {renderLineChart()}
            </div>
          </div>

          {/* Rating Distribution */}
          <div className="card">
            <div className="card-header">
              <h2 className="section-title">
                <i className="bi-star"></i> Rating Distribution
              </h2>
            </div>
            <div className="chart-container">
              <div className="rating-chart">
                {renderRatingChart()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MyMasterLayout>
  );
};

export default BasicAnalytics;